// src/contexts/AlertContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
    const [alert, setAlert] = useState(null); // { message: '...', type: 'success' | 'error' | 'info' }

    useEffect(() => {
        if (alert) {
            const timer = setTimeout(() => {
                setAlert(null);
            }, 3000); // Alert disappears after 3 seconds
            return () => clearTimeout(timer);
        }
    }, [alert]);

    const showAlert = (message, type = 'info') => {
        setAlert({ message, type });
    };

    return (
        <AlertContext.Provider value={{ showAlert }}>
            {children}
            {alert && (
                <div className={`fixed bottom-4 right-4 p-4 rounded-lg shadow-lg text-white z-[1000]
                    ${alert.type === 'success' ? 'bg-green-500' : ''}
                    ${alert.type === 'error' ? 'bg-red-500' : ''}
                    ${alert.type === 'info' ? 'bg-blue-500' : ''}
                `}>
                    {alert.message}
                </div>
            )}
        </AlertContext.Provider>
    );
};

export const useAlert = () => useContext(AlertContext);
